export default "__VITE_ASSET__bpI5AWtH__"